let setupSubsectionExpand = function(container) {
  $(container).find(".subsection-expand").find(".subsection-content").addClass("collapse");
  return $(container).find(".subsection-expand").on("click", ".subsection-title", function(event) {
   event.preventDefault();
   return $(this).closest(".subsection-expand").find(".subsection-content").collapse("toggle");
  });
};

$(document).ready(() => setupSubsectionExpand(document.body));



// WEBPACK FOOTER //
// ./app/webpack/frontend/initializers/subsection_expand.js